document.addEventListener('DOMContentLoaded', function () {
  const showcaseItems = document.querySelectorAll('.variant-showcase__item');
  if (!showcaseItems.length) return;


  // ─── Read More for Short Description ─────────────────────────────────────────

function initReadMore(container) {
  if (!container) return;

  const ul = container.querySelector('ul');
  if (!ul) return;

  const items = ul.querySelectorAll('li');
  if (items.length <= 3) {
    // Remove any existing read more button if list shrunk
    const existing = container.querySelector('.shortdesc-readmore');
    if (existing) existing.remove();
    items.forEach(function (li) { li.style.display = ''; });
    return;
  }

  // Hide items beyond 3
  items.forEach(function (li, i) {
    li.style.display = i >= 3 ? 'none' : '';
  });

  // Remove old button if re-initializing
  const oldBtn = container.querySelector('.shortdesc-readmore');
  if (oldBtn) oldBtn.remove();

  // Create Read More button
  const btn = document.createElement('button');
  btn.className = 'shortdesc-readmore';
  btn.textContent = 'Read more';
  btn.setAttribute('aria-expanded', 'false');

  btn.addEventListener('click', function () {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    items.forEach(function (li, i) {
      if (i >= 3) li.style.display = expanded ? 'none' : '';
    });
    btn.textContent = expanded ? 'Read more' : 'Read less';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  });

  ul.after(btn);
}

  // ─── Selectors ───────────────────────────────────────────────────────────────

  const mainImage = document.querySelector(
    '.product__media img, .product-single__photo img, [data-media-type="image"] img, .product__photo img'
  );

  // Dawn theme variant picker wrappers (all possible selectors)
  const variantPickerWrapper = document.querySelector(
    'variant-selects, variant-radios, .variant-selects, .variant-radios'
  );

  // Quantity selector wrapper (hide/show together with variant picker when needed)
 // const quantityWrapper = document.querySelector(
   // '#Quantity-Form-' + getActiveSectionId()
  //);

  // Price block (Dawn uses a <div id="price-SECTIONID"> wrapping the price component)
  const priceBlock = document.querySelector('[id^="price-"]');

  // Product form
  const productForm = document.querySelector('form[action="/cart/add"]');

  // ─── Helpers ─────────────────────────────────────────────────────────────────

  function getActiveSectionId() {
    // Extract section id from the product-info element
    const productInfo = document.querySelector('product-info[data-section]');
    return productInfo ? productInfo.dataset.section : '';
  }

function formatMoney(cents) {
  // Use Shopify's native formatter if available (respects store currency + format)
  if (window.Shopify && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, Shopify.money_format);
  }

  // Fallback: read currency symbol + format from the existing price element on the page
  const existingPrice = document.querySelector('.price-item bdi');
  if (existingPrice) {
    const text = existingPrice.textContent.trim();
    // Extract currency symbol (everything before the first digit)
    const symbol = text.match(/^[^\d]*/)?.[0] || '$';
    const amount = (cents / 100).toFixed(2);
    return symbol + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Last resort: plain number with 2 decimals, no symbol
  return (cents / 100).toFixed(2);
}

function updatePriceBlock(item) {
  if (!priceBlock) return;

  const price = parseInt(item.dataset.price || 0, 10);
  const comparePrice = parseInt(item.dataset.comparePrice || 0, 10);
  const formattedPrice = item.dataset.regprice;        // e.g. £199.00
  const formattedCompare = item.dataset.mcomparePrice; // e.g. £249.99

  const regularPriceWrapper = priceBlock.querySelector('.price__regular');
  const salePriceWrapper = priceBlock.querySelector('.price__sale');
  const saveBadge = priceBlock.querySelector('.price__save-badge, .badge.price__save-badge');

  const saveTextEl = item.querySelector('.save_newpercent');
  const saveText = saveTextEl ? saveTextEl.textContent.trim() : '';

  if (saveBadge && saveText) {
    saveBadge.textContent = saveText;
    saveBadge.style.display = '';
  }

  if (comparePrice > price) {
    console.log('priceBlock',priceBlock);
    // ON SALE
    if (regularPriceWrapper) regularPriceWrapper.classList.add('hidden');
    if (salePriceWrapper) {
      salePriceWrapper.classList.remove('hidden');
      const saleEl = salePriceWrapper.querySelector('.price-item--sale');
      const origEl = salePriceWrapper.querySelector('.price-item--regular');
      if (saleEl) saleEl.textContent = formattedPrice;
      if (origEl) origEl.textContent = formattedCompare;
    }
    priceBlock.classList.add('price--on-sale');
  } else {
    // REGULAR PRICE
   // priceBlock.classList.add('price--on-sale');
    priceBlock.classList.remove('price--on-sale');
    if (salePriceWrapper) salePriceWrapper.classList.add('hidden');
    if (regularPriceWrapper) {
      regularPriceWrapper.classList.remove('hidden');
      const regEl = regularPriceWrapper.querySelector('.price-item--regular');
      if (regEl) regEl.textContent = formattedPrice;
    }
  }


  
  
}

  function updateGalleryImage(item) {
    const imgUrl = item.dataset.imageUrl;
    const imgAlt = item.dataset.imageAlt || '';
    if (!mainImage || !imgUrl) return;

    mainImage.src = imgUrl;
    mainImage.alt = imgAlt;
    mainImage.srcset = imgUrl;

    // Update <picture> sources (Dawn theme uses these)
    const picture = mainImage.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (src) {
        src.srcset = imgUrl;
      });
    }

    // Dawn: also update the media slide li that's currently active
    const activeSlide = document.querySelector(
      '.product__media-item--active .product__media img, ' +
      '.product__media-list .slider__slide:first-child .product__media img'
    );
    if (activeSlide && activeSlide !== mainImage) {
      activeSlide.src = imgUrl;
      activeSlide.srcset = imgUrl;
    }
  }

  function loadAndRenderVariantPicker(item) {
    const hasVariants = item.dataset.hasVariants === 'true';
    const productHandle = item.dataset.productHandle;
    const sectionId = getActiveSectionId();

    if (!variantPickerWrapper) return;

    if (!hasVariants) {
      // No variants — just hide the picker
      variantPickerWrapper.style.display = 'none';
      return;
    }

    // Has variants — fetch the product's variant picker HTML via Shopify section rendering
    // and inject it, OR simply show the existing picker if it's the base product
    const currentProductHandle = document.querySelector('product-info')?.dataset?.url?.split('/products/')?.[1]?.split('?')?.[0];

    if (productHandle === currentProductHandle) {
      // Same product as page — just show the existing picker
      variantPickerWrapper.style.display = '';
    } else {
      // Different product — fetch its section HTML and replace the picker
      fetch('/products/' + productHandle + '?section_id=' + sectionId)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newPicker = doc.querySelector('variant-selects, variant-radios');
          if (newPicker && variantPickerWrapper) {
            variantPickerWrapper.innerHTML = newPicker.innerHTML;
            variantPickerWrapper.setAttribute('data-section', sectionId);
            variantPickerWrapper.setAttribute('data-url', '/products/' + productHandle);
            variantPickerWrapper.style.display = '';
            // Re-init Shopify's variant selection JS if available
            if (typeof variantPickerWrapper.connectedCallback === 'function') {
              variantPickerWrapper.connectedCallback();
            }
          }
        })
        .catch(function (err) {
          console.warn('Variant picker fetch failed:', err);
          variantPickerWrapper.style.display = '';
        });
    }
  }

  function updateProductForm(item) {
    if (!productForm) return;

    const variantId = item.dataset.variantId;
    const productUrl = item.dataset.productUrl;
    const hasVariants = item.dataset.hasVariants === 'true';

   // alert(variantId);

    // Update the hidden variant id input
    let variantInput1 = document.querySelector('input[name="id"]');
    let variantInput = document.querySelector('product-form input[name="id"]');
    
    if (variantInput && variantId) {
      variantInput.value = variantId;
    //  console.log('variantInput', variantInput.value);
    }

      if (variantInput1 && variantId) {
      variantInput1.value = variantId;
     // console.log('variantInput', variantInput.value);
    }

    // For multi-variant products, update the form's action/data-url
    // so Dawn's product-form.js targets the correct product
    if (productUrl) {
      productForm.setAttribute('action', '/cart/add');
      // Store selected product handle for Dawn's internal routing
      productForm.dataset.productUrl = productUrl;
    }

    // Update the buy-buttons add-to-cart submit to navigate to the correct product
    // if it has multiple variants (let Shopify handle variant selection on that product's page)
    const addToCartBtn = productForm.querySelector('[name="add"], [type="submit"]');
 
  }

  // ─── Main click handler ───────────────────────────────────────────────────────

  showcaseItems.forEach(function (item) {
    item.addEventListener('click', function () {
      // Deselect all, select clicked
      showcaseItems.forEach(function (el) { el.classList.remove('is-selected'); });
      item.classList.add('is-selected');

      // 1. Update gallery image
      updateGalleryImage(item);

      // 2. Update price display
      updatePriceBlock(item);

      // 3. Show/hide + reload variant picker
      loadAndRenderVariantPicker(item);

      // 4. Update product form to point to selected product/variant
      updateProductForm(item);

const shortdesc = item.querySelector('.pro_short_desc');
    const whatsincl = item.querySelector('.pro_whats_include');
   const pro_desc_data = item.querySelector('.pro_desc_data');

     let shortdesc_up = document.querySelector('.product__shortdesc');
     let whatsincl_up = document.querySelector('.what-sinclude-css');
      let prodescp = document.querySelector('.product_descdata');

    if(shortdesc && shortdesc_up){
     shortdesc_up.innerHTML = shortdesc.innerHTML;
     initReadMore(shortdesc_up);
    }

     if(pro_desc_data && prodescp){
     prodescp.innerHTML = pro_desc_data.innerHTML;
    }

     if(whatsincl && whatsincl_up){
      whatsincl_up.innerHTML = whatsincl.innerHTML;
    }


    });
  });

  // Trigger first item on load
  if (showcaseItems[0]) {
    showcaseItems[0].dispatchEvent(new Event('click'));
  }
});